import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHome, FaUserCircle } from 'react-icons/fa';
import '../admin/AdminDashboard.css';
import { CountAPI } from '../components/api';
import Footer from './Footer';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [counts, setCounts] = useState({ clerkCount: 0, assistantCount: 0 });
  const [showLogout, setShowLogout] = useState(false);

  useEffect(() => {
    fetch(CountAPI.getFormCounts)
      .then(res => res.json())
      .then(data => {
        setCounts({
          clerkCount: data.clerkCount || 0,
          assistantCount: data.assistantCount || 0,
        });
      })
      .catch(err => console.error('Error fetching counts:', err));
  }, []);

  const handleLogout = () => {
    navigate('/admin-login');
  };

  return (
    <>
    <div className="admin-dashboard">
      <div className="header1 row">
        <div className="left-header">
          <img src="/logo.png" alt="Logo" className="logo" />
          <span className="heading">सांगली शिक्षण संस्था, सांगली</span>
        </div>
        <div className="right-header">

          <FaUserCircle
            className="admin-icon"
            size={30}
            onClick={() => setShowLogout(!showLogout)}
          />
          {showLogout && (
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          )}
        </div>
      </div>

      <div className="admin-menu">
           <span
               className="menu-item"
                  onClick={() => navigate('/dashboard')}
                  style={{ cursor: 'pointer' }}>
                <FaHome/> होम पेज
              </span>
      <span
        className="menu-item"
        onClick={() => navigate('/clerk')}
        style={{ cursor: 'pointer' }}
      >
        कनिष्ठ लिपिक
      </span>

      <span
        className="menu-item"
        onClick={() => navigate('/assistant')}
        style={{ cursor: 'pointer' }}
      >
        प्रयोगशाळा सहाय्यक
      </span>
</div>

      <div className="menu-section">
        <h2>कनिष्ठ लिपिक</h2>
        <div className="count-box">
          <p>Applications Received</p>
          <h3>{counts.clerkCount}</h3>
        </div>

        <h2>प्रयोगशाळा सहाय्यक</h2>
        <div className="count-box">
          <p>Applications Received</p>
          <h3>{counts.assistantCount}</h3>
        </div>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default AdminDashboard;
